import { CLAUSE_LIBRARY } from '@Constants/types';
import { ClausesStatus } from '@Constants/status';

const initialState = {
    clauseLibraryLoadedState: ClausesStatus.NOT_LOADED,
    defaultClauseGroups: {},
    flattenClauseGroups: {},
    flattenedClauseIds: {},
    clauseGroupIds: {},
    selectedClauseId: null,
    navigating: false,
    navigatingTo: {},
    navigationFailedFlag: false,
    clearNavigateCountFlag: false,
    idx: {},
    isIndexing: false,
    indexingErr: '',
    isDrawerVisible: false
};

/* State Machine for the clauseReducer */
export default function clauseReducer(state = initialState, action) {
    switch (action.type) {
        case CLAUSE_LIBRARY.FETCH_LIBRARY_REQUEST:
            return {
                ...state,
                defaultClauseGroups: {},
                flattenClauseGroups: {},
                clauseGroupIds: [],
                clauseLibraryLoadedState: ClausesStatus.LOADING,
                selectedClauseId: null
            };
        case CLAUSE_LIBRARY.FETCH_LIBRARY_SUCCESS:
            return {
                ...state,
                defaultClauseGroups: action.payload.defaultClauseGroups,
                flattenClauseGroups: action.payload.flattenClauseGroups,
                clauseGroupIds: action.payload.clauseGroupIds,
                clauseLibraryLoadedState: ClausesStatus.LOADED,
                selectedClauseId: null
            };
        case CLAUSE_LIBRARY.FETCH_LIBRARY_FAILED:
            return {
                ...state,
                defaultClauseGroups: {},
                flattenClauseGroups: {},
                clauseGroupIds: {},
                clauseLibraryLoadedState: ClausesStatus.FAILED,
                selectedClauseId: null
            };
        case CLAUSE_LIBRARY.NO_PERMISSIONS:
            return {
                ...state,
                defaultClauseGroups: {},
                flattenClauseGroups: {},
                clauseGroupIds: {},
                clauseLibraryLoadedState: ClausesStatus.NO_PERMISSIONS,
                selectedClauseId: null
            };
        case CLAUSE_LIBRARY.FETCH_LIBRARY_TOKEN_EXPIRED:
            return {
                ...state,
                defaultClauseGroups: {},
                flattenClauseGroups: {},
                clauseGroupIds: {},
                clauseLibraryLoadedState: ClausesStatus.TOKEN_EXPIRED,
                selectedClauseId: null
            };
        // case CLAUSE_LIBRARY.CLAUSE_PREVIEW:
        //     return {
        //         ...state,
        //         navigating: false,
        //         navigationFailedFlag: false,
        //         selectedClauseId: action.payload
        //     };
        // case CLAUSE_LIBRARY.REFRESH_LIBRARY_UI:
        //     return {
        //         ...state
        //     };
        case CLAUSE_LIBRARY.CLEAR_CLAUSE_LIBRARY:
            return {
                ...state,
                defaultClauseGroups: {},
                flattenClauseGroups: {},
                clauseGroupIds: {},
                clauseLibraryLoadedState: ClausesStatus.NOT_LOADED,
                selectedClauseId: null
            };
        case CLAUSE_LIBRARY.INDEXING_CLAUSES_START:
            return {
                ...state,
                isIndexing: true
            };
        case CLAUSE_LIBRARY.INDEXING_CLAUSES_SUCCESS:
            return {
                ...state,
                idx: action.payload,
                isIndexing: false
            };
        case CLAUSE_LIBRARY.INDEXING_CLAUSES_FAILED:
            return {
                ...state,
                isIndexing: false,
                indexingErr: action.payload
            };
        case CLAUSE_LIBRARY.SET_DRAWER_OPEN_STATE:
            return {
                ...state,
                isDrawerVisible: action.payload
            };
        default:
            return state;
    }
}
